import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import shallow from "zustand/shallow";
import { FxButton } from "../button/FxButton";
import { FormComponent } from "../formcomponent/FormComponent";
import { FxIcon } from "../icon/FxIcon";
import { ListView } from "../listview/ListView";
import { session, useNavigation } from "../helpers";
import { TokenContext } from "../../../context-helpers/TokenContext";
import _ from "lodash";

export const useBaseList = (props: any) => {
    const { getToken } = React.useContext(TokenContext);

    const {
        storeHook,
        formRoute,
        customActionMap,
        customPageActionsMap,
        defaultMobileRowTemplate,
        defaultRowTemplate = null,
        fieldTemplates = {}
    } = props;

    const {
        pageConfig,
        getItems,
        getLookups,
        confirmDelete,
        items,
        filterModel,
        lookup,
        handleFilterInputChange,
        setFormOptions,
        setPagerOptions,
        setSorterOptions,
        pageChanged,
        sorterChanged,
        totalRecords,
        pageNo,
        processCascadingLookups } = storeHook((state: any) =>
        ({
            pageConfig: state.pageConfig,
            getItems: state.getItems,
            getLookups: state.getLookups,
            confirmDelete: state.confirmDelete,
            items: state.items,
            filterModel: state.filterModel,
            lookup: state.lookup,
            handleFilterInputChange: state.handleFilterInputChange,
            setFormOptions: state.setFormOptions,
            setPagerOptions: state.setPagerOptions,
            setSorterOptions: state.setSorterOptions,
            pageChanged: state.pageChanged,
            sorterChanged: state.sorterChanged,
            totalRecords: state.totalRecords,
            pageNo: state.pageNo,
            processCascadingLookups: state.processCascadingLookups
        }),
            shallow);
    const { navigate } = useNavigation();

    const getCompToken = async () => {
        let token: any = await getToken();
        session.setItem("accessToken", token);
    }

    useEffect(() => {
        getCompToken();
        preProcessListView();
        getItems();
        initLookup();
    }, []);

    const defaultConfig: any = pageConfig;
    const [config, setConfig] = useState(defaultConfig);
    const updateConfig = (data: any) => {
        setConfig((prevState: any) => {
            return { ...{}, ...data };
        })
    }

    const initLookup = async () => { await getLookups(); }

    const openForm = (id: any = "") => {
        let navData: any = {
            targetRoute: `${formRoute}/`
        };
        if (id) {
            navData["targetRoute"] = navData.targetRoute + id;
        } else {
            navData["targetRoute"] = navData.targetRoute + '0';
        }
        navigate(navData);
    }

    const preProcessListView = () => {
        for (let i in config.sections) {
            let section: any = config.sections[i];
            if (section.type == 'listview' && section.listViewConfig) {
                section.listViewConfig.fieldTemplates = {
                    actions: ({ row, fieldDef, index }: any) => <>
                        {renderActions(section.listViewConfig.actions, row)}
                    </>,
                    ...fieldTemplates
                };
                if (section.listViewConfig.pagerConfig) {
                    computePagerCallback(section.listViewConfig.pagerConfig);
                }
                if (section.listViewConfig.sorterConfig) {
                    section.listViewConfig.sorterConfig["onSortChanged"] = onSortChanged;
                    computeSorterCallback(section.listViewConfig.sorterConfig);
                }
            }
        }
    }

    const onSortChanged = (sorterConfig: any, column: any) => {
        let sorters: any = [];
        let sortInfo: any = sorterConfig.sortInfo;
        if (column.field == sortInfo.name) {
            sortInfo.direction = sortInfo.direction == 'desc' ? 'asc' : 'desc';
        } else {
            sortInfo.name = column.field;
            sortInfo.direction = 'asc';
        }
        sorters.push(sorterConfig.sortInfo);
        sorterChanged(sorters);
    }

    const computePagerCallback = (data: any) => {
        setPagerOptions(data);
    }

    const computeSorterCallback = (sorterConfig: any) => {
        setSorterOptions(sorterConfig);
    }

    useEffect(() => {
        preProcessListViewPager();
    }, [totalRecords]);

    const preProcessListViewPager = () => {
        let currentConfigItems: any = config;
        for (let i in currentConfigItems.sections) {
            let section: any = currentConfigItems.sections[i];
            if (section.type == 'listview' && section.listViewConfig && section.listViewConfig.pagerConfig) {
                section.listViewConfig.pagerConfig["pageChanged"] = pageChanged;
                section.listViewConfig.pagerConfig["totalRecords"] = totalRecords;
                console.log("useBaseList totalRecords : ", totalRecords);
                section.listViewConfig.pagerConfig["pageNo"] = pageNo;
            }
        }
        updateConfig(currentConfigItems);
    }

    const computeCallback = (data: any) => {
        setFormOptions(data);
    }

    const renderActions = (actions: any, row: any) => {
        return <>
            {actions.map((action: any, i: any) => (
                <>
                    {canShowAction(action, row) &&
                        <>
                            {actionMap[action.name] && actionMap[action.name](action, row)}
                            {!actionMap[action.name] && customActionMap[action.name](action, row)}
                        </>
                    }
                </>
            ))}
        </>
    }

    const canShowAction = (action: any, rowData: any) => {
        let row: any = rowData;
        if (action.controlRule?.visibleExpression) {
            let result = eval(action.controlRule?.visibleExpression);
            return result;
        }
        return true;
    }

    const getDisplayText = (action: any) => {
        return <span title={action.displayText} className={`font-13 text-${action.name == 'edit' ? 'primary' : 'danger'}`}>
            {action.displayText}
        </span>
    }

    const renderEditAction = (action: any, row: any) => {
        return <span className="m-right-2 pointer resposnive-icon" onClick={() => openForm(row._id)}>
            {action.displayText ? <>{getDisplayText(action)}</> : <FxIcon icon="fas fa-pencil-alt text-primary" />}
        </span>
    }

    const renderDeleteAction = (action: any, row: any) => {
        return <span className="m-right-2 pointer resposnive-icon" onClick={() => confirmDelete(row, action.placeholder)}>
            {action.displayText ? <>{getDisplayText(action)}</> : <FxIcon icon="far fa-trash-alt text-danger" />}
        </span>
    }

    const actionMap: any = {
        edit: renderEditAction,
        delete: renderDeleteAction,
    }

    const renderAddAction = (action: any, actionIdx: any) => {
        return <FxButton className="add-action" label={action.displayText ? action.displayText : "Add"} variant="contained" style={{ padding: '0' }} startIcon="fas fa-plus fa-xs" size="small" onClick={() => openForm("")} />
    }

    const renderFilter = (control: any, id: any) => {
        return <Box className="p-bottom-3" id="filterId">
            <FormComponent
                id={id}
                controls={control.controls}
                formModel={filterModel}
                layout={control.layout}
                lookup={lookup}
                handleInputChange={handleFilterInputChange}
                processCascadingLookups={processCascadingLookups}
                computeCallback={computeCallback} />
        </Box>
    }

    const getHeight = () => {
        let elm: any = document.getElementById("filterId");
        let height: any = "100%";
        if (elm) {
            height = "calc(100% - " + elm.clientHeight + "px)"
        }
        return height;
    }

    const renderListView = (control: any, id: any) => {
        let listViewConfig = { ...control.listViewConfig };
        let mobileListViewConfig = { ...control.listViewConfig };

        if (defaultMobileRowTemplate) {
            mobileListViewConfig.defaultRowTemplate = defaultMobileRowTemplate;
        }
        if (defaultRowTemplate) {
            listViewConfig.defaultRowTemplate = defaultRowTemplate;
        }

        return <>
            <Box sx={{ display: { xs: "block", md: "none" }, height: "100%", maxHeight: "100%" }}>
                <ListView id={id} config={defaultMobileRowTemplate ? { ...mobileListViewConfig, canShowHeader: false } : listViewConfig} items={items} lookup={lookup} />
            </Box>
            <Box sx={{ display: { xs: "none", md: "block" }, height: getHeight(), maxHeight: getHeight() }}>
                <ListView id={id} config={listViewConfig} items={items} lookup={lookup} />
            </Box>
        </>
    }

    const sectionMap: any = {
        filter: renderFilter,
        listview: renderListView
    }

    const pageActionsMap: any = {
        add: renderAddAction,
    }

    const renderList = () => {
        return (
            <div className="container-fluid">
                <Box className="content-heading">
                    <Box className="page-title">{config.pageTitle}</Box>
                    <Box>
                        {config && config.actionBar && config.actionBar.controls && config.actionBar.controls.map((action: any, actionIdx: any) => (
                            <>
                                {pageActionsMap[action.name] && pageActionsMap[action.name](action, actionIdx)}
                                {!pageActionsMap[action.name] && customPageActionsMap[action.name](action, actionIdx)}
                            </>
                        ))}
                    </Box>
                </Box>

                <Box className="content-body">
                    {config && config.sections && config.sections.map((control: any, idx: any) => (
                        <>
                            {sectionMap[control.type](control, idx)}
                        </>
                    ))}
                </Box>
            </div>
        );
    }

    return { getItems, getLookups, confirmDelete, items, filterModel, lookup, handleFilterInputChange, renderList };
}